import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nida-web-overview-patients',
  templateUrl: './overview-patients.component.html',
  styleUrls: ['./overview-patients.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class OverviewPatientsComponent {}
